import { render, staticRenderFns } from "./batchBeans.vue?vue&type=template&id=359722b4&scoped=true"
import script from "./batchBeans.vue?vue&type=script&lang=js"
export * from "./batchBeans.vue?vue&type=script&lang=js"
import style0 from "./batchBeans.vue?vue&type=style&index=0&id=359722b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359722b4",
  null
  
)

export default component.exports